var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"crop-image"},[(_vm.imageSrc)?_c('img',{ref:"image",staticClass:"crop-image__img",style:(_vm.imageStyle),attrs:{"src":_vm.imageSrc},on:{"load":_vm.emitCurrentCrop}}):_c('div',{staticClass:"crop-image__placeholder"},[_vm._v("Изображение не выбрано")])])
}
var staticRenderFns = []

export { render, staticRenderFns }